<template>
    <div>
        <site-header></site-header>
        <div class="c-t-company">
            <transition name="o-transition--fade" mode="out-in">
                <div
                    class="c-t-company__main"
                    v-if="!isLoading && !error"
                    key="content"
                >
                    <company-header :company="company"></company-header>
                    <company-menu :menu_items="menuItems"></company-menu>
                    <section-presentation
                        v-if="
                            company.Presentation ||
                                company.PresentationHtml ||
                                1 == 1
                        "
                        :company="company"
                    >
                    </section-presentation>
                    <section-references
                        v-if="company.References.length > 0"
                        :references="company.References"
                        :companyName="company.Name"
                    ></section-references>
                    <!-- <section-quality v-if="company.Quality" :orgNr="orgNr" :quality="company.Quality" :certificates="company.Certificates"></section-quality> -->
                    <section-ratings
                        id="ratings"
                        v-if="company.Ratings.length > 0"
                        :company="company"
                    ></section-ratings>
                    <section-certificates
                        v-if="company.Certificates.length > 0 && hasProvenCerts"
                        :certificates="company.Certificates"
                    ></section-certificates>

                    <section-contact
                        :contactInfo="contactInfo"
                    ></section-contact>
                </div>
                <div
                    class="c-t-request__main"
                    v-else-if="isLoading && !error"
                    key="loading"
                >
                    <loader class="c-m-loader--x-large" />
                </div>
                <div class="c-t-company__main" v-else key="error 1">
                    <error-state
                        v-bind="errorStateContent"
                        hideIcon
                    ></error-state>
                </div>
            </transition>
        </div>
        <site-footer></site-footer>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
    FETCH_COMPANY_BY_ID,
    FETCH_COMPANY_BY_SLUG,
    GET_COMPANY,
    GET_ERROR,
    IS_LOADING
} from "../store/store-models/company-model";

import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";

import ErrorState from "./components/molecules/MoleculeErrorState.vue";
import Loader from "./components/molecules/MoleculeLoader.vue";

import CompanyMenu from "./components/molecules/MoleculeCompanyMenu.vue";
import CompanyHeader from "./components/organisms/company-sections/OrganismCompanyHeader.vue";
import SectionCertificates from "./components/organisms/company-sections/OrganismCompanySectionCertificates.vue";
import SectionContact from "./components/organisms/company-sections/OrganismCompanySectionContact.vue";
import SectionPresentation from "./components/organisms/company-sections/OrganismCompanySectionPresentation.vue";
import SectionQuality from "./components/organisms/company-sections/OrganismCompanySectionQuality.vue";
import SectionRatings from "./components/organisms/company-sections/OrganismCompanySectionRatings.vue";
import SectionReferences from "./components/organisms/company-sections/OrganismCompanySectionReferences.vue";

import { companySchema } from "./../helpers";

export default {
    async created() {
        const { identifier } = this.$route.params;

        if (isNaN(identifier)) {
            const response = await this.$store.dispatch(
                FETCH_COMPANY_BY_SLUG,
                identifier
            );

            if (response.data && response.data.Id) {
                this.$router.push(`/hantverkare/${response.data.Id}`);
            }
        } else {
            await this.$store.dispatch(FETCH_COMPANY_BY_ID, identifier);
        }
    },
    components: {
        SiteHeader,
        SiteFooter,
        CompanyHeader,
        SectionPresentation,
        SectionQuality,
        SectionRatings,
        SectionReferences,
        SectionContact,
        SectionCertificates,
        Loader,
        ErrorState,
        CompanyMenu
    },
    computed: {
        ...mapGetters({
            company: GET_COMPANY,
            isLoading: IS_LOADING,
            error: GET_ERROR
        }),
        orgNr: function() {
            if (!this.company.OrgNr) return "";

            let result = this.company.OrgNr;

            if (
                this.company.Quality &&
                this.company.Quality.CompanyForm == "Enskild firma"
            ) {
                result =
                    result.indexOf("-") > -1
                        ? result.slice(0, -5)
                        : result.slice(0, -4);
            }

            return result;
        },
        hasProvenCerts: function() {
            let certs = [];

            this.company.Certificates.find(cert => {
                certs.push(cert.Proven);
            });

            return certs.includes(true) ? true : false;
        },
        contactInfo: function() {
            const obj = {
                visitAddress: this.company.VisitAddress,
                visitCity: this.company.VisitCity,
                phone: this.company.Phone,
                email: this.company.Email,
                url: this.company.Url,
                latitude: this.company.Latitude,
                longitude: this.company.Longitude
            };
            return obj;
        },
        schemaData: function() {
            if (!this.company.Id) return "";
            const data = companySchema(this.company);
            return JSON.stringify(data);
        },
        bcName: function() {
            if (!this.isLoading && !this.error) {
                return this.company.Name ? this.company.Name : "Hantverkare";
            } else if (this.isLoading && !this.error) {
                return "Laddar...";
            } else {
                return "Fel";
            }
        },
        metaContent: function() {
            if (!this.isLoading && !this.error) {
                return this.company.Name
                    ? `${this.company.Name} är en av alla våra anslutna hantverkare. Gör en förfrågan på BraByggare och få svar från relevanta hantverkare nära dig.`
                    : "Detta är en av alla våra anslutna hantverkare. Hitta rätt företag för just ditt uppdrag.";
            } else if (this.isLoading && !this.error) {
                return "Laddar...";
            } else {
                return "Företaget kunde inte hittas. Det kan ha raderats eller så kan länken du följde vara felaktig. Om problemet kvarstår, kontakta gärna vår kundtjänst.";
            }
        },
        canonicalLink: function() {
            if (!this.company.Id) return "";

            const baseUrl = process.env.SITE_BASE_URL;
            const currentPath = this.$route.path;

            let href = `${baseUrl}${currentPath}`;
            return { rel: "canonical", href: href };
        },
        errorStateContent: function() {
            let content = {
                heading: "Sidan kunde inte hittas",
                body:
                    "<p>Länken till sidan du försöker hämta fungerar inte.</p>",
                button: {
                    label: "Till startsidan",
                    icon: "home",
                    classes: "c-a-button--theme-primary",
                    to: "/"
                }
            };

            if (this.error && this.error.statusCode === 404) {
                if (this.error.name == "NotFound") {
                    content = {
                        ...content,
                        heading: "Företaget kunde inte hittas",
                        body:
                            '<p>Det kan ha raderats eller så kan länken du följde vara felaktig.</p><p>Om problemet kvarstår kan du kontakta kundtjänst på <a href="mailto:info@brabyggare.se">info@brabyggare.se</a></p>'
                    };
                } else if (this.error.name == "NoContent") {
                    let heading = this.error.companyName
                        ? this.error.companyName
                        : "Företaget";
                    content = {
                        hideIcon: true,
                        heading: `${heading} ingår inte i vår kvalitetskontroll`,
                        body:
                            "<p>Företaget använder inte längre BraByggares tjänster och står därmed utom vår kvalitetskontroll.</p>",
                        button: {
                            label: "Hitta andra hantverkare",
                            icon: "",
                            classes: "c-a-button--theme-primary",
                            to: "/sok-hantverkare/"
                        },
                        metaObject: {
                            title: this.error.companyName
                        }
                    };
                }
            }

            return content;
        },
        menuItems: function() {
            let items = [];

            items.push({
                name: "Presentation",
                id: "presentation",
                icon: "info"
            });

            if (this.company.References && this.company.References.length) {
                items.push({
                    name: "Referensjobb",
                    id: "reference-jobs",
                    icon: "hammer"
                });
            }
            if (this.company.Ratings && this.company.Ratings.length) {
                items.push({
                    name: "Omdömen",
                    id: "ratings",
                    icon: "star"
                });
            }
            if (
                this.company.Certificates &&
                this.company.Certificates.length &&
                this.hasProvenCerts
            ) {
                items.push({
                    name: "Certifieringar",
                    id: "certificates",
                    icon: "certificate"
                });
            }

            items.push({
                name: "Kontakt",
                id: "contact",
                icon: "mail"
            });

            return items;
        }
    },
    metaData() {
        return {
            title: this.bcName,
            meta: [
                {
                    vmid: "description",
                    name: "description",
                    content: this.metaContent
                }
            ],
            script: [
                { innerHTML: this.schemaData, type: "application/ld+json" }
            ],
            link: [this.canonicalLink]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Company.vue